<div class="standorte-tab">
    <div class="actions-row">
        <div class="actions-left">
            <div *kienePermission="[9352]">
                <button
                    mat-flat-button
                    color="accent"
                    (click)="standortwechsel()"
                    [disabled]="gruppe?.historie > 0 || loadingOrSaving || !canUseStandortwechsel()"
                >
                    <mat-icon>swap_horiz</mat-icon>
                    <span>&nbsp;Standort wechseln</span>
                </button>
            </div>
            <button (click)="loadStandorte()" mat-flat-button color="accent" [disabled]="loadingOrSaving">
                <mat-icon>refresh</mat-icon>
                <span>&nbsp;Aktualisieren</span>
            </button>
            <ng-container *ngIf="darfBio()">
            <ng-container *kienePermission="[9378]">
                <div class="price-summary-actions" *ngIf="standorte?.length">
                    <button
                        mat-stroked-button
                        color="accent"
                        (click)="gewichtePreiseEingebenEinstallen(firstStandort)"
                        [disabled]="!canEditStandorte || loadingOrSaving || !firstStandort"
                    >
                        <mat-icon>scale</mat-icon>
                        <span>&nbsp;Einstallgewichte & Preise</span>
                    </button>
                    <button
                        mat-stroked-button
                        color="accent"
                        (click)="gewichtePreiseEingebenAusstallen(lastStandort)"
                        [disabled]="!canEditStandorte || loadingOrSaving || !lastStandort"
                    >
                        <mat-icon>scale</mat-icon>
                        <span>&nbsp;Abgangsgewichte & Preise</span>
                    </button>
                </div>
            </ng-container>
            </ng-container>
        </div>
        <ng-container *ngIf="darfBio()">
        <ng-container *kienePermission="[9162]">
            <div class="price-summary-row" *ngIf="standorte?.length">
                <kiene-key-value-list>
                    <kiene-key-value-list-item
                        key="&Oslash; Einkaufspreise / {{ firstStandort?.einkaufspreis_avg?.anzahl || 0 }} Tier(e)"
                        value="{{ firstStandort?.einkaufspreis_avg?.wert | number: '1.2-2' }} &euro;"
                    ></kiene-key-value-list-item>
                    <kiene-key-value-list-item
                        key="&Oslash; Verkaufspreise/ {{ lastStandort?.verkaufspreis_avg?.anzahl || 0 }} Tier(e)"
                        value="{{ lastStandort?.verkaufspreis_avg?.wert | number: '1.2-2' }} &euro;"
                    ></kiene-key-value-list-item>
                </kiene-key-value-list>
            </div>
        </ng-container>
        </ng-container>
    </div>

    <div class="timeline-list">
        <div class="timeline-list-item" *ngFor="let s of standorte; let i = index" [class.is-open]="isStandortExpanded(i)">
            <button class="timeline-summary" type="button" (click)="toggleStandortDetails(i)">
                <span class="timeline-step">{{ i + 1 }}</span>
                <span class="timeline-date-group">
                    <mat-icon class="timeline-inline-icon">event</mat-icon>
                    <span class="timeline-date"
                        >{{ (s.datum_von | date: "dd.MM.yy") || "---" }}
                        {{ s.datum_bis ? " - " + (s.datum_bis | date: "dd.MM.yy") : "" }}</span
                    >
                </span>
                <span class="timeline-location-group">
                    <mat-icon class="timeline-inline-icon">location_on</mat-icon>
                    <span class="timeline-location">{{ getStandortLabel(s, i) }}</span>
                </span>
                <button
                    mat-icon-button
                    class="timeline-menu-button"
                    color="accent"
                    *kienePermission="[9352, 9378]"
                    [matMenuTriggerFor]="editMenu"
                    [disabled]="!canEditStandorte"
                    (click)="$event.stopPropagation()"
                >
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-icon class="timeline-chevron">{{ isStandortExpanded(i) ? "expand_less" : "expand_more" }}</mat-icon>
            </button>

            <div class="timeline-content" [class.timeline-content-open]="isStandortExpanded(i)">
                <div class="timeline-content-inner">
                    <kiene-key-value-list>
                        <kiene-key-value-list-item key="Standort" [value]="getStandortLabel(s, i)"></kiene-key-value-list-item>

                        <kiene-key-value-list-item key="Produktionsabschnitt" [value]="s.produktionsabschnitt"></kiene-key-value-list-item>
                        <kiene-key-value-list-item *ngIf="s.sgs_nummer" key="SGS Nummer" [value]="s.sgs_nummer"></kiene-key-value-list-item>
                        <ng-container *ngIf="darfBio()">
                        <ng-container *kienePermission="[9161]">
                            <kiene-key-value-list-item
                                key="Einstallgewicht / {{ getStandortEinstallTierCount(s) || getStandortTierCount(s, i) }} Tier(e)"
                                value="{{ getStandortEinstallgewichtTotal(s, i) | number: '1.1-1' }} kg"
                            ></kiene-key-value-list-item>

                            <kiene-key-value-list-item
                                key="Abgangsgewicht / {{ getStandortAbgangTierCount(s, i) || getStandortTierCount(s, i) }} Tier(e)"
                                value="{{ getStandortAbgangsgewichtTotal(s, i) | number: '1.1-1' }} kg"
                            ></kiene-key-value-list-item>

                            <kiene-key-value-list-item
                                key="Tageszunahmen / {{ getStandortTierCount(s, i) }} Tier(e)"
                                value="{{ getStandortTageszunahmen(s, i) | number: '1.1-1' }} kg"
                            ></kiene-key-value-list-item>
                        </ng-container>
                        </ng-container>
                    </kiene-key-value-list>
                </div>
            </div>
            <mat-menu #editMenu>
                <button
                    *kienePermission="[9352]"
                    mat-menu-item
                    (click)="editStandort(s, i)"
                    [disabled]="!canEditStandorte || loadingOrSaving || gruppe?.historie > 0"
                >
                    <mat-icon>edit</mat-icon>
                    <span>Bearbeiten</span>
                </button>
                <ng-container *ngIf="i > 0">
                    <button
                        *kienePermission="[9378]"
                        mat-menu-item
                        (click)="deleteStandort(s)"
                        [disabled]="!canEditStandorte || loadingOrSaving"
                    >
                        <mat-icon>delete</mat-icon>
                        <span>Löschen</span></button
                    >
                </ng-container>
                <ng-container *ngIf="darfBio() && i > -1 && gruppe?.rind > 0">
                    <button
                        *kienePermission="[9378]"
                        mat-menu-item
                        (click)="einzeltiergewichtEintragen(s)"
                        [disabled]="!canEditStandorte || loadingOrSaving"
                    >
                        <mat-icon>scale</mat-icon>
                        <span>&nbsp;Einzeltiergewicht eintragen</span></button
                    >
                </ng-container>
            </mat-menu>
        </div>
    </div>

    <!--    <ng-container *ngIf="false || appService.isMobileScreen">-->

    <!--        <mat-stepper [orientation]="stepperOrientation" style="margin-top: 24px; width: 100%;" [linear]="false"-->
    <!--                     #stepper>-->
    <!--            <mat-step *ngFor="let s of standorte; let i = index" [completed]="true">-->
    <!--                <ng-template matStepLabel>-->
    <!--                    <div class="one-row">-->
    <!--                <span style="font-weight: bold;">{{(s.datum_von | date: 'dd.MM.yy') || '-&#45;&#45;'}} {{s.datum_bis ? (' - ' +-->
    <!--                    (s.datum_bis | date: 'dd.MM.yy')) : ''}}</span>-->
    <!--                        <button mat-icon-button color="accent" *kienePermission="[9352,9378]"-->
    <!--                                [matMenuTriggerFor]="editMenu">-->
    <!--                            <mat-icon>more_vert</mat-icon>-->
    <!--                        </button>-->
    <!--                        <mat-menu #editMenu>-->
    <!--                            <button *kienePermission="[9352]" mat-menu-item (click)="editStandort(s, i)"-->
    <!--                                    [disabled]="loadingOrSaving">-->
    <!--                                <mat-icon>edit</mat-icon>-->
    <!--                                <span>Bearbeiten</span>-->
    <!--                            </button>-->
    <!--                            <ng-container *ngIf="i > 0">-->
    <!--                                <button *kienePermission="[9378]" mat-menu-item (click)="deleteStandort(s)"-->
    <!--                                        [disabled]="loadingOrSaving">-->
    <!--                                    <mat-icon>delete</mat-icon>-->
    <!--                                    <span>Löschen</span></button>-->
    <!--                            </ng-container>-->
    <!--                            <ng-container *ngIf="i === 0">-->
    <!--                                <button *kienePermission="[9378]" mat-menu-item-->
    <!--                                        (click)="gewichtePreiseEingebenEinstallen(s)"-->
    <!--                                        [disabled]="loadingOrSaving">-->
    <!--                                    <mat-icon>scale</mat-icon>-->
    <!--                                    <span>&nbsp;Einstallgewichte &-->
    <!--                                Preise</span></button>-->
    <!--                            </ng-container>-->
    <!--                            <ng-container *ngIf="i > -1">-->
    <!--                                <button *kienePermission="[9378]" mat-menu-item (click)="einzeltiergewichtEintragen(s)">-->
    <!--                                    <mat-icon>scale</mat-icon>-->
    <!--                                    <span>&nbsp;Einzeltiergewicht eintragen</span></button>-->
    <!--                            </ng-container>-->
    <!--                            <ng-container *ngIf="i >= standorte?.length-1">-->
    <!--                                <button mat-menu-item (click)="gewichtePreiseEingebenAusstallen(s)"-->
    <!--                                        *kienePermission="[9378]"-->
    <!--                                        [disabled]="loadingOrSaving">-->
    <!--                                    <mat-icon>scale</mat-icon>-->
    <!--                                    <span>&nbsp;Abgangsgewichte & Preise</span>-->
    <!--                                </button>-->
    <!--                            </ng-container>-->
    <!--                        </mat-menu>-->
    <!--                    </div>-->
    <!--                </ng-template>-->
    <!--                <kiene-key-value-list>-->
    <!--                    <kiene-key-value-list-item key="Standort" [value]="s.stall"></kiene-key-value-list-item>-->

    <!--                    <kiene-key-value-list-item key="Produktionsabschnitt"-->
    <!--                                               [value]="s.produktionsabschnitt"></kiene-key-value-list-item>-->
    <!--                    <ng-container *kienePermission="[9161]">-->
    <!--                        <kiene-key-value-list-item-->
    <!--                            key="&Oslash; Einstallgewicht / {{s.einstallgewicht_avg?.anzahl || 0}} Tier(e)"-->
    <!--                            value="{{(s.einstallgewicht_avg?.wert | number:'1.1-1')}} kg"></kiene-key-value-list-item>-->

    <!--                        <kiene-key-value-list-item-->
    <!--                            key="&Oslash; Abgangsgewicht / {{s.abgangsgewicht_avg?.anzahl || 0}} Tier(e)"-->
    <!--                            value="{{(s.abgangsgewicht_avg?.wert | number:'1.1-1')}} kg"></kiene-key-value-list-item>-->

    <!--                        <kiene-key-value-list-item-->
    <!--                            key="&Oslash; Tageszunahmen / {{s.tageszunahmen_avg?.anzahl || 0}} Tier(e)"-->
    <!--                            value="{{(s.tageszunahmen_avg?.wert | number:'1.1-1')}} kg"></kiene-key-value-list-item>-->
    <!--                    </ng-container>-->
    <!--                    <ng-container *kienePermission="[9162]">-->
    <!--                        <kiene-key-value-list-item *ngIf="i === 0"-->
    <!--                                                   key="&Oslash; Einkaufspreise / {{s.einkaufspreis_avg?.anzahl || 0}} Tier(e)"-->
    <!--                                                   value="{{(s.einkaufspreis_avg?.wert | number:'1.2-2')}} &euro;"></kiene-key-value-list-item>-->

    <!--                        <kiene-key-value-list-item *ngIf="i >= standorte?.length -1"-->
    <!--                                                   key="&Oslash; Verkaufspreise/ {{s.verkaufspreis_avg?.anzahl || 0}} Tier(e)"-->
    <!--                                                   value="{{(s.verkaufspreis_avg?.wert | number:'1.2-2')}} &euro;"></kiene-key-value-list-item>-->

    <!--                        <kiene-key-value-list-item *ngIf="i >= standorte?.length -1"-->
    <!--                                                   key="&Oslash; Erl&ouml;sdifferenz/ {{s.erloesdifferenz_avg?.anzahl || 0}} Tier(e)"-->
    <!--                                                   value="{{(s.erloesdifferenz_avg?.wert | number:'1.2-2')}} &euro;"></kiene-key-value-list-item>-->

    <!--                    </ng-container>-->
    <!--                </kiene-key-value-list>-->

    <!--            </mat-step>-->
    <!--            <mat-step *kienePermission="[9352]">-->
    <!--                <ng-template matStepLabel>Standort wechseln</ng-template>-->
    <!--                <button mat-flat-button color="accent" (click)="standortwechsel()" [disabled]="loadingOrSaving">-->
    <!--                    <mat-icon>swap_horiz</mat-icon>-->
    <!--                    <span>&nbsp;Wechseln</span>-->
    <!--                </button>-->
    <!--            </mat-step>-->
    <!--        </mat-stepper>-->
    <!--    </ng-container>-->
</div>
